import $ from 'qwery';

const hiddenClass = 'is-hidden';
const showOnClickAttr = 'data-show-click';
const hideOnClickAttr = 'data-hide-click';

export function showElements (selectors) {
    for (const key in selectors) {
        if (selectors.hasOwnProperty(key)) {
            $(selectors[key]).forEach(element => {
                element.classList.remove(hiddenClass);
            });
        }
    }
}

export function hideElements (selectors) {
    for (const key in selectors) {
        if (selectors.hasOwnProperty(key)) {
            $(selectors[key]).forEach(element => {
                element.classList.add(hiddenClass);
            });
        }
    }
}

function showOnClick (event) {
    const targets = event.currentTarget.getAttribute(showOnClickAttr);
    if (targets) {
        showElements(JSON.parse(targets));
    }
}

function hideOnClick (event) {
    const targets = event.currentTarget.getAttribute(hideOnClickAttr);
    if (targets) {
        hideElements(JSON.parse(targets));
    }
}

(function init () {
    $('[data-hide-click]').forEach(hideControl => {
        hideControl.addEventListener('click', hideOnClick, false);
    });
    $('[data-show-click]').forEach(showControl => {
        showControl.addEventListener('click', showOnClick, false);
    });
}());
